import { IAppState } from '@myStore/app.state';
import { IESDPChangesState } from '@myStore/ESDP-changes/ESDP-changes.state';
import { createSelector } from '@ngrx/store';

const ESDPChangesSelector = (state: IAppState) => state.ESDPChanges;

export const selectChangesESDPLoading = createSelector(
  ESDPChangesSelector,
  (state: IESDPChangesState) => state?.isLoading
);

export const selectChangesESDPSuccess = createSelector(
  ESDPChangesSelector,
  (state: IESDPChangesState) => state?.success
);

export const selectChangesESDPErrors = createSelector(
  ESDPChangesSelector,
  (state: IESDPChangesState) => state?.errors
);

export const selectCreateESDPTeamsErrors = createSelector(
  ESDPChangesSelector,
  (state: IESDPChangesState) => state?.createTeamsErrors
);
